
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";
import "./AverageRiskChart.css";

const data = [
  { month: "Jan", value: 100 },
  { month: "Feb", value: 85 },
  { month: "Mar", value: 90 },
  { month: "Apr", value: 78 },
  { month: "May", value: 98 },
  { month: "Jun", value: 88 },
  { month: "Jul", value: 60 },
  { month: "Aug", value: 88 },
  { month: "Sep", value: 105 },
  { month: "Oct", value: 102 },
  { month: "Nov", value: 88 },
  { month: "Dec", value: 98 }
];

export default function AverageRiskChart() {
  return (
    <div className="_risk_card">
      <h3 className="_risk_title">Average risk over time</h3>

      <div className="_risk_chart_wrapper">
        <ResponsiveContainer width="100%" height={280}>
          <BarChart
            data={data}
            barSize={42}
            margin={{ top: 20, right: 20, left: 10, bottom: 10 }}
          >
            <defs>
              <linearGradient id="riskGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#0b2233" />
                <stop offset="45%" stopColor="#0b2233" />
                <stop offset="100%" stopColor="#ffffff" />
              </linearGradient>
            </defs>

            <CartesianGrid
              vertical={false}
              strokeDasharray="3 3"
              stroke="#e5e7eb"
            />

            <YAxis
              domain={[0, 100]}
              ticks={[0, 50, 100]}
              tickFormatter={(v) => `${v}%`}
              axisLine={false}
              tickLine={false}
              width={40}
            />

            <XAxis
              dataKey="month"
              axisLine={false}
              tickLine={false}
            />

            <Bar
              dataKey="value"
              fill="url(#riskGradient)"
              radius={[8, 8, 0, 0]}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
